const templateGroup = {
    namespaced: true,
    state: {
        beforeSelectedTextDom: null,
        beforeSelectedItem: null, // 用来记录失去焦点后的text数据，便于更新dom
        selectedTextDom: null,
        selectedItem: null, // 模板素材选中、素材替换通过当前选中的对象来操作
        materialGroupList: [], //素材组
        cropperDialogVisible: false,
        selectedItemForModuleGroup: {
            item: null,
            parent: null
        },
        focusCssText: null,
        wordTableList: [],
        globalModuleItem: null,
        globalModuleVisible: false,
        attrActiveName: '1',// 面板中，右侧tab
        multiImgItems: [],
        treePanelRef: null,
        leftActiveNames: ['2', '3'], // 面板中，左侧collapse
        tableThemeList: [],
        moduleGroupVisibleTooltip: true, //鼠标hover模块组时，显示操作按钮，但编辑文本时，挡住视线，所以通过此属性在编辑时隐藏按钮
        pageBgItem: null, //模板背景对象
    },
    mutations: {
        set_selected_item(state, item) {
            state.selectedItem = item;
        },
        set_selected_dom(state, dom) {
            state.selectedTextDom = dom;
        },
        set_selected_item_attr(state, item) {
            Object.assign(state.selectedItem, item);
        },
        toggle_cropper_dialog(state, trueOrFalse) {
            state.cropperDialogVisible = trueOrFalse;
        },
        set_module_group_selected(state, {item, parent}) {
            state.selectedItemForModuleGroup = {
                item, parent
            };
        },
        set_css_text(state, item) {
            state.focusCssText = item;
        },
        set_before_focus_item(state, {dom, item}) {
            state.beforeSelectedTextDom = dom;
            state.beforeSelectedItem = item;
        },
        set_global_module(state, item) {
            state.globalModuleItem = item;
        },
        toggle_global_modal_dialog(state, trueOrFalse) {
            state.globalModuleVisible = trueOrFalse;
        },
        set_attr_tab(state, activeName) {
            state.attrActiveName = activeName;
        },
        add_multi_img(state, item) {
            let hasVal = state.multiImgItems.some((data) => {
                return item === data;
            })
            if (!hasVal) {
                state.multiImgItems.push(item);
            }
        },
        clear_multi_img(state, item) {
            state.multiImgItems = [];
        },
        set_tree_panel_ref(state, dom) {
            state.treePanelRef = dom;
        },
        set_left_active_name(state, arr) {
            state.leftActiveNames = arr;
        },
        set_table_theme(state, data) {
            state.tableThemeList = data;
        },
        set_tooltip(state, trueOrFalse) {
            state.moduleGroupVisibleTooltip = trueOrFalse;
        },
        set_bg_item(state, item) {
            state.pageBgItem = item;
        },
    },
    actions: {}
}
export default templateGroup;
